import { render } from "./TermsOfServiceModal.vue?vue&type=template&id=2a5bd0fa&scoped=true"
import script from "./TermsOfServiceModal.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceModal.vue?vue&type=script&lang=js"

import "./TermsOfServiceModal.vue?vue&type=style&index=0&id=2a5bd0fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5bd0fa"]])

export default __exports__